export const PartnerSetttings = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="9" cy="13" r="4" stroke="currentColor" stroke-width="2"/>
<circle cx="23" cy="9" r="4" stroke="currentColor" stroke-width="2"/>
<path d="M23 2V5" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M23 13V16" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M30 9L27 9" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M19 9L16 9" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M27.9497 4.05029L25.8284 6.17161" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M20.1716 11.8284L18.0502 13.9497" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M27.9497 13.9497L25.8284 11.8284" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M20.1716 6.17163L18.0502 4.05031" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M15 30V25C15 22.7909 13.2091 21 11 21H7C4.79086 21 3 22.7909 3 25V30" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
